import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagUG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M43.632 41.667A24.904 24.904 0 0 0 50 25a24.905 24.905 0 0 0-6.368-16.667L25 6.522 6.368 8.333A24.905 24.905 0 0 0 0 25a24.905 24.905 0 0 0 6.368 16.667L25 43.478l18.632-1.811Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M6.368 8.333h37.264C39.054 3.22 32.404 0 25 0 17.596 0 10.945 3.22 6.368 8.333Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m0 25 25 2.174L50 25c0-2.922-.503-5.727-1.425-8.333H1.425A24.952 24.952 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M1.425 33.333h47.15A24.956 24.956 0 0 0 50 25H0c0 2.922.503 5.727 1.425 8.333Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M43.632 41.666H6.368C10.945 46.782 17.596 50 25 50c7.404 0 14.054-3.22 18.632-8.334Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M33.342 25A8.342 8.342 0 0 1 25 33.342 8.342 8.342 0 0 1 16.657 25 8.342 8.342 0 0 1 25 16.658 8.342 8.342 0 0 1 33.342 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M28.056 25.425 25 24.101s.715-2.373.753-2.536a1.625 1.625 0 0 0-.435-1.522l.769-.768a2.709 2.709 0 0 0-1.922-.796c-.75 0-1.43.304-1.921.796l.768.768a1.625 1.625 0 0 0-.407 1.626l-1.157 1.157h2.103s-.87 1.306-1.344 2.379c-.475 1.072.006 2.382 1.104 2.87l.634.281 1.055.992v1.087l-1.087 1.087h2.174v-2.174l.992-.992h2.052l.03-.061a2.174 2.174 0 0 0-1.105-2.87Z"
}));
FlagUG.displayName = 'FlagUG';
export default withFlagWrapper(FlagUG);
//# sourceMappingURL=index.js.map